import { AlertTriangle, RefreshCw } from '../../../../../icons';
import { Button } from '../../../../ui/button';

const ICON_PX = 20;
const RETRY_ICON_PX = 14;
const LOAD_ERROR_TITLE = "This video couldn't be loaded.";
const LOAD_ERROR_BODY = 'Check your connection, then try again.';
const RETRY_LABEL = 'Try again';
/** White pill: the overlay is near-black. */
const RETRY_BUTTON_CLASS = 'rounded-full border-white bg-white px-3 text-zinc-900 hover:bg-white/90 hover:text-zinc-900';

export interface VideoLoadErrorProps {
  onRetry: () => void;
}

/**
 * Laid over the stage once the video has failed for good — after its fresh
 * link and, for a source that never loaded, its plain (non-CORS) load too —
 * so the reviewer sees why the player is blank and can try again.
 */
export function VideoLoadError({ onRetry }: VideoLoadErrorProps) {
  return (
    <div
      role="alert"
      data-testid="video-load-error"
      className="absolute inset-0 z-6 flex flex-col items-center justify-center gap-3 bg-black/80 p-6 text-center text-stone-100"
    >
      <AlertTriangle size={ICON_PX} aria-hidden="true" />
      <div className="space-y-1">
        <p className="text-body-sm-semibold">{LOAD_ERROR_TITLE}</p>
        <p className="text-caption-regular text-stone-300">{LOAD_ERROR_BODY}</p>
      </div>
      <Button type="button" variant="outline" size="xs" onClick={onRetry} className={RETRY_BUTTON_CLASS}>
        <RefreshCw size={RETRY_ICON_PX} aria-hidden="true" />
        {RETRY_LABEL}
      </Button>
    </div>
  );
}
